import { triggerBlobDownload } from '@/utils/triggerBlobDownload';

export const downloadAsCsv = (values: string[]) => {
  const csv = values.join('\n');
  const blob = new Blob([csv], { type: 'text/csv' });
  triggerBlobDownload(blob, 'key.csv');
};
